import { Injector } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypesService } from '@fi-app/utilities/fi-services/object-types.service';

export abstract class AreaDeleteCardBase {
    objectTypes: ObjectTypesService;
    appTextService: AppTextService;

    constructor(protected injector: Injector) {
        this.objectTypes = this.injector.get(ObjectTypesService);
        this.appTextService = this.injector.get(AppTextService);
    }

    joinSummaryGroup(group: Array<string>) {
        if (group.length > 1) {
            group.splice(
                group.length - 2,
                2,
                group[group.length - 2] +
                    ' ' +
                    this.appTextService.get('and').toLowerCase() +
                    ' ' +
                    group[group.length - 1],
            );
        }
        return group.join(', ');
    }
}
